import { render } from "./PageSkeleton.vue?vue&type=template&id=135883ac&scoped=true"
import script from "./PageSkeleton.vue?vue&type=script&lang=js"
export * from "./PageSkeleton.vue?vue&type=script&lang=js"

import "./PageSkeleton.vue?vue&type=style&index=0&id=135883ac&scoped=true&lang=css"

import exportComponent from "/builds/off-group-apps/personal-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135883ac"]])

export default __exports__